import { type FunctionComponent } from "react";

import quickBooksIconSmall from "images/Accounting/QuickBooks/QuickBooksIconSmall.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedQuickbooks: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img
            alt=""
            src={quickBooksIconSmall}
            style={baseProps.style}
            className={baseProps.className}
        />
    );
};
